/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesForAzure extends models.SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesForAzure.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesForAzure>): SelfServiceDefaultValuesForAzure {
        let obj = Object.assign(new SelfServiceDefaultValuesForAzure(), model);
        SelfServiceDefaultValuesForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesForAzure>): SelfServiceDefaultValuesForAzure {
        if (!model) return null;
        return SelfServiceDefaultValuesForAzure.newInstance(<SelfServiceDefaultValuesForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesForAzure) {
        if (!obj) return;

        models.SelfServiceDefaultValuesForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesForAzure): boolean {
        if (models.SelfServiceDefaultValuesBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Default Location
     */
    locations: string;

    /**
     * Default ResourceGroup
     */
    resource_group: string;

    /**
     * Default Virtual Network
     */
    virtual_network: string;

    /**
     * Default Storage Account
     */
    storage_account: string;

    /**
     * Default Subnet
     */
    subnet: string;

    /**
     * Whether resourceGroup configurable or not
     */
    is_resource_group_configurable: boolean;

}
